export class CoreFilters {
  constructor() {}

  showFiltered($forShow, showItems) {
    $forShow.each((i, el) => {
      const $t = $(el);
      if (i < showItems) {
        $t.removeClass('filter-hide');
      } else {
        $t.addClass('filter-hide');
      }
    });
  }

  checkLoadMore(
    $forShow,
    $loadMore,
    $hideAll,
    $empty,
    showItems,
    showItemsStep
  ) {
    if ($forShow.length <= showItemsStep) {
      $loadMore.addClass('hide');
      $hideAll.addClass('hide');

      if ($forShow.length === 0) {
        $empty.addClass('show');
      } else {
        $empty.removeClass('show');
      }
    } else if (
      $forShow.length > showItemsStep &&
      $forShow.length <= showItems
    ) {
      $empty.removeClass('show');
      $loadMore.addClass('hide');
      $hideAll.removeClass('hide');
    } else {
      $empty.removeClass('show');
      $loadMore.removeClass('hide');
      $hideAll.addClass('hide');
    }
  }
}
